<button
  type="button"
  class="input input-bordered flex h-10 w-full items-center gap-2 rounded-full px-4 text-left transition-all focus:!border-primary focus:!outline-none focus-visible:!border-primary focus-visible:!outline-none"
  [class.border-white/30]="!light"
  [class.bg-white/10]="!light"
  [class.text-white]="!light"
  [class.backdrop-blur-sm]="!light"
  [class.hover:bg-white/15]="!light"
  aria-haspopup="dialog"
  aria-label="Search campaigns, fundraisers, teams and charities"
  (click)="openSearch()"
>
  <ui-icon name="search" [size]="15" class="shrink-0 opacity-70"></ui-icon>
  <span
    class="grow truncate text-sm"
    [class.text-white/60]="!light"
    [class.text-base-content/40]="light"
  >
    Try 'Gaza Emergency Appeal'
  </span>
  @if (!light) {
    <kbd class="kbd kbd-sm shrink-0 border-white/30 bg-white/10 text-white/70">⌘K</kbd>
  }
</button>
